/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddBotMessageRequest,
  SaveInitialBotMessageRequest,
  VehicleDetailsCardDTO,
  WidgetChatMessage,
  WidgetChatRequest,
  WidgetChatResponse,
  WidgetSettings,
  WidgetUserInitializationResponse,
} from '../models';

export interface AddBotMessageOperationRequest {
    chatId: string;
    addBotMessageRequest: AddBotMessageRequest;
}

export interface GetChatHistoryRequest {
    chatId: string;
}

export interface GetVehicleDetailsCardContentRequest {
    publicBotId: string;
    vin: string;
}

export interface GetWidgetSettingsRequest {
    publicBotId: string;
}

export interface InitializeUserRequest {
    publicBotId: string;
}

export interface QueryRequest {
    widgetChatRequest: WidgetChatRequest;
}

export interface SaveInitialBotMessageOperationRequest {
    chatId: string;
    saveInitialBotMessageRequest: SaveInitialBotMessageRequest;
}

/**
 *
 */
export class WidgetControllerApi extends runtime.BaseAPI {

    /**
     */
    async addBotMessageRaw(requestParameters: AddBotMessageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetChatMessage>> {
        if (requestParameters['chatId'] == null) {
            throw new runtime.RequiredError(
                'chatId',
                'Required parameter "chatId" was null or undefined when calling addBotMessage().'
            );
        }

        if (requestParameters['addBotMessageRequest'] == null) {
            throw new runtime.RequiredError(
                'addBotMessageRequest',
                'Required parameter "addBotMessageRequest" was null or undefined when calling addBotMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/public/widget/{chatId}/add-bot-message`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters['chatId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['addBotMessageRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async addBotMessage(requestParameters: AddBotMessageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetChatMessage> {
        const response = await this.addBotMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getChatHistoryRaw(requestParameters: GetChatHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WidgetChatMessage>>> {
        if (requestParameters['chatId'] == null) {
            throw new runtime.RequiredError(
                'chatId',
                'Required parameter "chatId" was null or undefined when calling getChatHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/widget/history/{chatId}`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters['chatId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getChatHistory(requestParameters: GetChatHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WidgetChatMessage>> {
        const response = await this.getChatHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getVehicleDetailsCardContentRaw(requestParameters: GetVehicleDetailsCardContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleDetailsCardDTO>> {
        if (requestParameters['publicBotId'] == null) {
            throw new runtime.RequiredError(
                'publicBotId',
                'Required parameter "publicBotId" was null or undefined when calling getVehicleDetailsCardContent().'
            );
        }

        if (requestParameters['vin'] == null) {
            throw new runtime.RequiredError(
                'vin',
                'Required parameter "vin" was null or undefined when calling getVehicleDetailsCardContent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/widget/vehicle-card/bot/{publicBotId}/vin/{vin}`.replace(`{${"publicBotId"}}`, encodeURIComponent(String(requestParameters['publicBotId']))).replace(`{${"vin"}}`, encodeURIComponent(String(requestParameters['vin']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getVehicleDetailsCardContent(requestParameters: GetVehicleDetailsCardContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleDetailsCardDTO> {
        const response = await this.getVehicleDetailsCardContentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getWidgetSettingsRaw(requestParameters: GetWidgetSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetSettings>> {
        if (requestParameters['publicBotId'] == null) {
            throw new runtime.RequiredError(
                'publicBotId',
                'Required parameter "publicBotId" was null or undefined when calling getWidgetSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/widget/settings/{publicBotId}`.replace(`{${"publicBotId"}}`, encodeURIComponent(String(requestParameters['publicBotId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getWidgetSettings(requestParameters: GetWidgetSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetSettings> {
        const response = await this.getWidgetSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async initializeUserRaw(requestParameters: InitializeUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetUserInitializationResponse>> {
        if (requestParameters['publicBotId'] == null) {
            throw new runtime.RequiredError(
                'publicBotId',
                'Required parameter "publicBotId" was null or undefined when calling initializeUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/widget/{publicBotId}/initialize-user`.replace(`{${"publicBotId"}}`, encodeURIComponent(String(requestParameters['publicBotId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async initializeUser(requestParameters: InitializeUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetUserInitializationResponse> {
        const response = await this.initializeUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async queryRaw(requestParameters: QueryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetChatResponse>> {
        if (requestParameters['widgetChatRequest'] == null) {
            throw new runtime.RequiredError(
                'widgetChatRequest',
                'Required parameter "widgetChatRequest" was null or undefined when calling query().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/public/widget/query`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['widgetChatRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async query(requestParameters: QueryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetChatResponse> {
        const response = await this.queryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveInitialBotMessageRaw(requestParameters: SaveInitialBotMessageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetChatMessage>> {
        if (requestParameters['chatId'] == null) {
            throw new runtime.RequiredError(
                'chatId',
                'Required parameter "chatId" was null or undefined when calling saveInitialBotMessage().'
            );
        }

        if (requestParameters['saveInitialBotMessageRequest'] == null) {
            throw new runtime.RequiredError(
                'saveInitialBotMessageRequest',
                'Required parameter "saveInitialBotMessageRequest" was null or undefined when calling saveInitialBotMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/public/widget/{chatId}/save-initial-bot-message`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters['chatId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['saveInitialBotMessageRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async saveInitialBotMessage(requestParameters: SaveInitialBotMessageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetChatMessage> {
        const response = await this.saveInitialBotMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
